import {
  Grid,
  Typography,
  Box,
  Link,
  useTheme,
  useMediaQuery,
} from '@mui/material'
import React from 'react'
import location from '../../Assets/Icons/location.svg'
import message from '../../Assets/Icons/message.svg'
import phoneIcon from '../../Assets/Icons/Phone_orage_icon.svg'

const ContactUs = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'))

  const ContactItem = ({ icon, children, ...props }) => (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        mb: 2,
        '& img': {
          mr: 2,
          width: 24,
          height: 24,
        },
      }}
      {...props}
    >
      <img src={icon} alt="" />
      <Typography variant="body1" component="div">
        {children}
      </Typography>
    </Box>
  )

  return (
    <Box
      sx={{
        py: { xs: 4, md: 8 },
        px: { xs: 2, sm: 4, md: 6 },
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Grid container spacing={4}>
        {/* Contact Information */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h4"
                component="h2"
                gutterBottom
                sx={{
                  fontWeight: 'bold',
                  color: theme.palette.text.primary,
                }}
              >
                Contact Us
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  color: theme.palette.text.secondary,
                  mb: 3,
                }}
              >
                Got something that you would like posted to us? We're all ears!
                Make sure you write in your contact information so we can get
                back to you at the earliest.
              </Typography>
            </Box>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <ContactItem icon={location}>
                  AP Housing Board, Baghlingampally,
                  <br />
                  New Nallakunta, Hyderabad,
                  <br />
                  Telangana 500044
                </ContactItem>
              </Grid>

              <Grid item xs={12} sm={6}>
                <ContactItem icon={message}>
                  <Link href="mailto:helpdesk@dbraei.edu.in" color="primary">
                    helpdesk@dbraei.edu.in
                  </Link>
                </ContactItem>

                <ContactItem icon={phoneIcon}>
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Link href="tel:040-27670675" color="primary">
                      040 – 2767 06 75
                    </Link>
                    <Link href="tel:+919100221282" color="primary">
                      +91 9100221282
                    </Link>
                  </Box>
                </ContactItem>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* Google Map */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              height: '100%',
              minHeight: { xs: 300, md: 'auto' },
              borderRadius: 2,
              overflow: 'hidden',
              boxShadow: 3,
            }}
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7614.449523899285!2d78.499843!3d17.400998!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99bf3d11314b%3A0xc93bceef6f9b1a70!2sDr.%20BR%20Ambedkar%20college%2C%20AP%20Housing%20Board%2C%20Bagh%20Lingampally%2C%20New%20Nallakunta%2C%20Hyderabad%2C%20Telangana%20500044!5e0!3m2!1sen!2sin!4v1701691900210!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="College Location Map"
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default ContactUs
